import axios from 'axios';

const axiosInstance = axios.create({
  // baseURL: API_URL,
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.response.use((response) => {
  console.log('Valid response');
  console.dir(response);
  // Do something with response data
  return response;
}, (error) => {
  // TODO  29 Aug 2018 - CW : Trap all 403 responses and send 403 for all errors from the backend
  return Promise.reject(error);
});

export default axiosInstance;
